import React from 'react'
import { makeStyles } from '@mui/styles'
import FloatingBadge, { Varients } from '@/modules/base/components/badge/floating-badge'
import lang from '@/lang'
import { useAppSelector } from '@/redux/store'

const useStyles = makeStyles({
  container: {
    cursor: 'pointer',
    gap: 10,
  },
})

export default function StopDemoNotch() {
  const classes = useStyles()

  const isDemo = useAppSelector(state => state.user.info?.isDemo)

  if (!isDemo) return

  return (
    <FloatingBadge id="pendo-stop-demo-notch" className={classes.container} varient={Varients.PRIMARY_LIGHT}>
      <span>{lang.endDemoModusConfirmTitle}</span>
    </FloatingBadge>
  )
}
